export default __webpack_public_path__ + "static/media/mascot-protectors-unite.c9603ef6.gif";